import { execute } from 'fg-frontend/src/partialUpdate/partialUpdate';

export const eshopUserToolsRefresh = () => {
  execute({
    target: [ 'userLists', 'userListsRwd' ],
    url:    `/qf/${ window.projectConfig.lang }/ramjet/include`,
  });

  const freeShippingWidget = document.querySelector('#discountShippingInfo')
  if ( freeShippingWidget ) {
    fetch(`/qf/${ window.projectConfig.lang }/ramjet/include@shoppingCartMenuPopup_content_discountShippingInfo`)
      .then(resp => {
        if ( resp.status === 200 ) {
          return resp.text()
        }
      })
      .then(code => {
        freeShippingWidget.innerHTML = code;
      })
      .catch(e => console.error(e));
  }
};



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/webActions/eshopUserToolsRefresh.js